import { render, staticRenderFns } from "./CommodGoods.vue?vue&type=template&id=6399998f&scoped=true"
import script from "./CommodGoods.vue?vue&type=script&lang=js"
export * from "./CommodGoods.vue?vue&type=script&lang=js"
import style0 from "./CommodGoods.vue?vue&type=style&index=0&id=6399998f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6399998f",
  null
  
)

export default component.exports